import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ServiceOrderHistory = {
	name: NAME,
	apiProvider,
	router,
};
